import React from 'react';
import './footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <div className='row'>
            <div className='col-lg-4 firstsec'>
<h3>BI <span>Manager</span></h3>
<p>
Submit a clear request detailing <br/>what you need—products, services,<br/> quantities, and delivery requirements.
</p>
            </div>
            <div className='col-lg-4  secondsec'>
                <h4>Quick Links</h4>
                <div className='row mt-5'>
                    <div className='col-lg-6'>
                    <ul>
              <li><a href="/">How It Works</a></li>
              <li><a href="/">Create RFQ</a></li>
              <li><a href="/">Browse RFQs</a></li>
              <li><a href="/">For Vendors</a></li>
            </ul>

                    </div>
                    <div className='col-lg-6'>
                    <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/faqs">FAQs</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
                    </div>
                </div>
            </div>
            <div className='col-lg-4 thirdsec'>
                <h5>
                Sign up to receive news and <br/>
                updates.
                </h5>
                <input type='text' className='inputfooter'/><br/>
                <button className='buttonfooter'>
                    SEND
                </button>
            </div>
        </div>
        {/* POWERED BY SECTION */}
        <div className="footer-bottom text-center mt-4 pt-3">
          <p className="mb-1">
            © {new Date().getFullYear()} BI Manager. All Rights Reserved.
          </p>
         <p className="powered-by">
  Developed by{" "}
  <a
    href="https://thenexteck.com/"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "#FF650F", textDecoration: "none" }}
  >
    <strong>The Nexteck</strong>
  </a>
</p>

        </div>
      </div>
    </div>
  );
};

export default Footer;
